import {
  React,
  Component
} from 'imports/CommonImports';

class StageDoneMessage extends Component {

  render() {
    if(this.props.stage.name === 'WS')
      return (
        <div>
          <h1>Se debe realizar el workshop</h1>
          <h2>INNSPIRAL se comunicará contigo para organizar un workshop con los líderes de los proyectos, si tienes dudas puedes contactarnos.</h2>
        </div>
      )
    else
      return(
        <div>
          <h1>Esta etapa aún no comienza</h1>
          <h2>Debes realizar las tareas asignadas del proceso i3 para poder visualizar la etapa</h2>
        </div>
      );
  }
}

export default StageDoneMessage;



// WEBPACK FOOTER //
// ./src/components/common/StageNotReadyMessage.js